import React from 'react';
import { Link } from "react-router-dom";
import { FiArrowRight } from "react-icons/fi";
import SEO from "../common/SEO";
import HeaderTwo from '../common/header/HeaderTwo';
import SectionTitle from "../elements/sectionTitle/SectionTitle";
import BenefitSection from "../elements/benefit/BenefitSection";
import BenefitSection2 from "../elements/benefit/BenefitSection2";
import StopShop from "../elements/service/StopShop";
import BenefitEmployee from "../elements/service/BenefitEmployee";
import FooterTwo from '../common/footer/FooterTwo';
import Copyright from '../common/footer/Copyright';
import Separator from "../elements/separator/Separator";
import { useTranslation } from "react-i18next";


const Benefits = () => {
    const { t } = useTranslation('enterprise');
    const BenefitData = [
        {
            title: t('avantages.title'),
            description: t('avantages.subtitle'),
        },
    ]
    const EmpData = [
        {
            title: t('avantages.creerDuLien.title'),
            description: t('avantages.creerDuLien.content'),
        },
    ]
    return (
        <>
            <SEO title="Acquitision rétention Talents - Acquire and retain Talents Engagement loyalty fidélité - people involved pruchasing power - Pouvoir Achat Rétention Retain " />
            <main className="page-wrapper  main-mobile-responsive">
                <HeaderTwo btnStyle="btn-small btn-icon" HeaderSTyle="header-transparent" />

                {/* Start Slider Area  */}
                <div className="slider-area slider-style-1 variation-default height-850 bg_image" data-black-overlay="1" >
                    {BenefitData.map((data) => (
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-6">
                                <div className="inner text-left">
                                    <h1 className="title display-one cust-title mt-5" dangerouslySetInnerHTML={{__html: data.title}}></h1>
                                    <p className="description" style={{ fontSize: '20px' }} dangerouslySetInnerHTML={{__html: data.description}}></p>
                                    <div className="button-group">
                                        <Link className="btn-default btn-medium btn-icon" to="/offers">{t('footer.offres')}<i className="icon"><FiArrowRight /></i></Link>
                                    </div>
                                </div>
                            </div>
                            <div className='col-lg-6'>
                                <img style={{ marginLeft: '80px', marginTop: '80px' }} className="bannerimg" src="/images/bg/hero-img-n01zet-avantages.png" alt='benefits'/>
                            </div>
                        </div>
                    </div>
                    ))}
                </div>
                {/* End Slider Area  */}

                {/* Start Employees  */}
                <div className="about-area about-style-4 rn-section-gap">
                    {EmpData.map((data) => (
                    <div className="container">
                        <div className="row row--40 align-items-center pt-5 pb-5 lt-display">
                            <div className="col-lg-6 mt_md--40 mt_sm--40">
                                <div className="content">
                                    <div className="inner">
                                        <h3 className="title" dangerouslySetInnerHTML={{__html: data.title}}></h3>
                                        <ul className="feature-list">
                                            <li dangerouslySetInnerHTML={{__html: data.description}}></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                    <div className="video-btn">
                                        <img src={t('avantages.creerDuLien.imgSrc')} alt="process" width={"500px"}/>
                                    </div>
                            </div>
                        </div>
                    </div>
                    ))} 
                </div>  
                {/* End Employees  */}
                <Separator />
                {/* Start Service Area  */}
                <div className="rn-service-area rn-section-gap ">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <SectionTitle
                                    textAlign="text-center"
                                    radiusRounded=""
                                    subtitle=""
                                    title= {t('avantages.raisons.title')}
                                    description={t('avantages.raisons.subtitle')}
                                />
                            </div>
                        </div>
                        <BenefitSection 
                         number="01."
                         title={t('avantages.raisons.un.title')}
                         description={t('avantages.raisons.un.content')}
                         image="/images/split/benefits-1.png"
                        />
                        <BenefitSection2 
                         number="02."
                         title={t('avantages.raisons.deux.title')}
                         description={t('avantages.raisons.deux.content')}
                         image="/images/split/benefits-2.png"
                        />
                        <BenefitSection 
                         number="03."
                         title={t('avantages.raisons.trois.title')}
                         description={t('avantages.raisons.trois.content')}
                         image="/images/split/benefits-3.png"
                        />
                        <BenefitSection2 
                         number="04."
                         title={t('avantages.raisons.quatre.title')}
                         description={t('avantages.raisons.quatre.content')}
                         image="/images/split/benefits-4.png"
                        />
                        <BenefitSection 
                         number="05."
                         title={t('avantages.raisons.cinq.title')}
                         description={t('avantages.raisons.cinq.content')}
                         image="/images/split/benefits-5.png"
                        />
                        <div className='text-center pt-5 mt-5'>
                        <Link className="btn-default btn-medium btn-icon" to="/contact">{t('buttons.demo')}<i className="icon"><FiArrowRight /></i></Link>
                        </div>
                    </div>
                </div>
                {/* End Service Area  */}
                <Separator />
                {/* Start Benefit Employees Area  */}
                <div className="rn-service-area rn-section-gap ">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <SectionTitle
                                    textAlign="text-center"
                                    radiusRounded=""
                                    subtitle=""
                                    title={t('avantages.lesAvantagesSalaries.title')}
                                    description={t('avantages.lesAvantagesSalaries.subtitle')}
                                />
                            </div>
                        </div>
                        <BenefitEmployee
                            serviceStyle="service__style--1 radius mt--20 rbt-border responsive-tabs"
                            textAlign="text-left"
                        />
                        <div className='p-5 text-center'>
                            <img src={t('avantages.lesAvantagesSalaries.imgSrc')} alt='process' />
                        </div>
                        <div className='text-center pt-5 mt-5'>
                        <Link className="btn-default btn-medium btn-icon" to="#">{t('buttons.learnMore')}<i className="icon"><FiArrowRight /></i></Link>
                        </div>

                    </div>
                </div>
                {/* End Benefit Employees Area  */}

                <Separator />   
                {/* Start Service Area  */}
                <div className="rn-service-area rn-section-gap ">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <SectionTitle
                                    textAlign="text-center"
                                    radiusRounded=""
                                    subtitle=""
                                    title={t('footer.offres')}
                                    description=""
                                />
                            </div>
                        </div>
                        <StopShop
                            serviceStyle="service__style--1 radius mt--20 rbt-border"
                            textAlign="text-left"
                        />
                    </div>
                </div>
                {/* End Service Area  */}

                <FooterTwo />
                <Copyright />
            </main>
        </>
    )
}

export default Benefits
